import * as actionType from "../constants";
import * as commonData from "../Common";

export const updateSingleRow = (input, any) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  const kesy = Object.keys(input);
  let finaldata = "";

  let form = {};
  for (const key in input) {
    if (Array.isArray(input[key])) {
      form = {
        ...form,
        [key]: input[key],
      };
    } else {
      form = {
        ...form,
        [key]: input[key],
      };
    }
  }
  try {
    const response = await fetch(`${url}tattle/update`, {
      method: "post",
      body: JSON.stringify(form),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      if (any == "status") {
        return rdata;
      }
      dispatch({
        type: actionType.UPDATE_SINGLE_ROW,
        payload: {
          rows: rdata.data,
          message: rdata.message,
          title: rdata.status,
          board: true,
        },
      });
      setTimeout(() => {
        dispatch({ type: actionType.UPDATE_SINGLE_BOARD_FALSE });
      }, 3000);
      dispatch(
        getBoardHistory(
          {
            customer_tattle_uuid: +input.customer_tattle_uuid,
            attribute_set_key: input.attribute_set_key,
            app_token: input.app_token,
          },
          any
        )
      );
      return rdata;
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const getBoardHistory =
  (inputs, any = null) =>
  async (dispatch) => {
    const api = commonData.commonData().apiUrl;
    try {
      const resp = await fetch(`${api}tattle/get-history`, {
        method: "post",
        body: JSON.stringify(inputs),
      });
      const rdata = await resp.json();
      if (rdata.code === 200) {
        if (any == "status") {
          return rdata;
        }
        dispatch({
          type: actionType.GET_ALL_BOARD_HISTORY,
          payload: {
            history: rdata.data,
            hisAttributes: rdata?.attributes || {},
          },
        });
      } else {
        if (any == "status") {
          return rdata;
        }
        dispatch({
          type: actionType.GET_ALL_BOARD_HISTORY,
          payload: {
            history: [],
            hisAttributes: rdata?.attributes || {},
          },
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

export const assignToUpdate = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
};
export const updateAssignTo = (inputs, any) => async (dispatch) => {
  try {
    const api = commonData.commonData().apiUrl;
    const resp = await fetch(`${api}tattle/update-assignto`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await resp.json();
    if (rdata.code === 200) {
      if (any == "status") {
        return rdata;
      }
      dispatch({
        type: actionType.ASSIGN_TO_UPDATE,
        payload: {
          assign: rdata.data.attribute_value,
          message: rdata.message,
          title: rdata.status,
          board: true,
        },
      });
      dispatch(
        getBoardHistory(
          {
            attribute_set_key: inputs.attribute_set_key,
            app_token: inputs.app_token,
            customer_tattle_uuid: inputs.customer_tattle_uuid,
          },
          any
        )
      );
      return rdata;
    }
  } catch (error) {
    console.log(error);
  }
};
